import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import md5 from 'js-md5';
// import "element-ui/lib/theme-chalk/index.css";
import ElementUI from 'element-ui';
Vue.use(ElementUI, { size: 'medium', zIndex: 3000 });

import API from './http/api';
import http from './http/http';
import affirm from '@/affirm'; // 确认弹框
Vue.prototype.$API = API;
Vue.prototype.$http = http;
Vue.prototype.$md5 = md5;
Vue.prototype.$affirm = affirm;
Vue.prototype.$wxOriginalUrl = window.location.href.split('#')[0]

// 引入全局注册组件
import './globalComponent';

Vue.config.productionTip = false;

import '@/styles/index.scss'; // 默认皮肤样式
import '@/iconfont/default/iconfont.css'; // 引入自定义图标
import '@/iconfont/color/iconfont.css'; // 引入自定义图标

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
